import { Col, Form, Row, Select } from "antd";
import type React from "react";

const { Option } = Select;

type MemberPaymentMethodFilterProps = {
	className?: string;
};

export const MemberPaymentMethodFilter: React.FC<
	MemberPaymentMethodFilterProps
> = ({ className = "mb-4" }) => {
	return (
		<Row gutter={[16, 16]} justify="start">
			<Col xs={{ span: 24 }}>
				<Form.Item name="paymentMethod" className={className}>
					<Select placeholder="決済方法を選択" allowClear>
						<Option value="card">カード決済</Option>
						<Option value="on_site">現地決済</Option>
					</Select>
				</Form.Item>
			</Col>
		</Row>
	);
};
